import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const LoginButton = ({ mode }: { mode: string }) => {
  const { t } = useTranslation();

  const textColor = mode === "light" ? "text-black" : "text-white";

  return (
    <div className="flex flex-col items-center pb-1">
      <span className={`text-base ${textColor} text-center`}>
        {t("alreadyHaveAccount")}
      </span>
      <span className="text-center">
        <Link
          to="/login"
          className="cursor-pointer text-20 text-sangati-orange font-bold underline"
        >
          {t("signInButton")}
        </Link>
      </span>
    </div>
  );
};

export default LoginButton;
